// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import React from 'react';
import { Box, Chip } from '@mui/material';
import {
  CADENCE_PRESETS,
  matchCadencePreset,
  type RecurringFrequency,
} from '@crm-src/lib/cadence';

/**
 * One-click billing-cadence presets (Monthly / Quarterly / Half-yearly /
 * Yearly). Shared by the inline scheduling card and the standalone recurring
 * modal so both offer the same options. Selecting a chip sets BOTH frequency
 * and interval; the flexible frequency/interval controls remain alongside.
 */
export interface CadencePresetChipsProps {
  frequency: RecurringFrequency;
  interval: number;
  onSelect: (frequency: RecurringFrequency, interval: number) => void;
}

export const CadencePresetChips: React.FC<CadencePresetChipsProps> = ({
  frequency,
  interval,
  onSelect,
}) => {
  const active = matchCadencePreset(frequency, interval);
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }} data-testid="cadence-presets">
      {CADENCE_PRESETS.map((preset) => {
        const isActive = active === preset.id;
        return (
          <Chip
            key={preset.id}
            label={preset.label}
            size="small"
            clickable
            data-testid={`cadence-preset-${preset.id}`}
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onSelect(preset.frequency, preset.interval)}
          />
        );
      })}
    </Box>
  );
};
